import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';

export interface ICmmsFilterEmittedValue {
	columnName: string;
	label: string;
	data: any;
}

export interface ICmmsFilterWithDefaultData {
	getDefaultFilterValue: (entity?) => Observable<ICmmsFilterEmittedValue>;
}

export function isICmmsFilterWithDefaultData(
	obj: any
): obj is ICmmsFilterWithDefaultData {
	return 'getDefaultFilterValue' in obj;
}

export interface ICmmsFilterWithDataSetter {
	setFilterValue: (entity?) => void;
}

export function isICmmsFilterWithDataSetter(obj: any): obj is ICmmsFilterWithDataSetter {
	return 'setFilterValue' in obj;
}

export interface ICmmsFilterComponent {
	filterValueChanged: EventEmitter<ICmmsFilterEmittedValue>;
	data?: {
		preselectedValue?: any;
		activePage?: CmmsPages;
		columnName?: string;
		options?: { [key: string]: any };
	};
	ngOnInit?: () => void;
}
